// transform file name to shorter
export const fileNameFormatter = (fileName, maxSymbols) => {
  const lastDotPosition = fileName.lastIndexOf('.');
  const nameWithoutExtension = lastDotPosition !== -1 ? fileName.substring(0, lastDotPosition) : fileName;
  const extension = lastDotPosition !== -1 ? fileName.substring(lastDotPosition) : '';
  const shortName = (nameWithoutExtension.length > maxSymbols) ? nameWithoutExtension.substring(0, maxSymbols) + '...' : nameWithoutExtension;

  return `${shortName} ${extension}`;
}

// convert bytes to megabytes
export const fileSizeFormatter = (fileSize) => {
  const sizeInMb = fileSize / 1000000;
  return sizeInMb < 1 ? sizeInMb.toFixed(2) : sizeInMb.toFixed(1);
}

// to sanitize input texts
export function sanitize(str) {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
  };
  const reg = /[&<>"'/]/gi;
  const sanitized = str.replace(reg, (match) => map[match]);
  return sanitized.replace(/( {2,})/i, ' ');
}

export const categorizeItems = (items) => {
  const categoryCounts = items.reduce((acc, item) => {
    const category = item.category;
    acc[category] = acc[category] ? acc[category] + 1 : 1;
    return acc;
  }, {});

  return Object.keys(categoryCounts).map(category => ({
    category: category,
    length: categoryCounts[category]
  }));
};

export const fetcher = (...args) => fetch(...args).then(res => res.json());